import { getCollegeYears } from "./helpers";
/* istanbul ignore next */

var env = process.env.CHEGG_ENV === 'prod' ? 'prod' : 'test';
export var initialState = {
  env: env,
  clientId: 'CHGG',
  showBack: false,
  country: '',
  locale: 'en',
  pxCaptchaType: undefined,
  sso: {
    email: '',
    authProvider: '',
    authProviderToken: ''
  },
  signin: {
    credentials: {
      email: {
        changed: false,
        touched: false,
        valid: false,
        value: '',
        focus: false,
        error: '',
        valueChanged: false
      },
      password: {
        changed: false,
        touched: false,
        valid: false,
        value: '',
        focus: false,
        valueChanged: false
      },
      error: ''
    },
    loading: false
  },
  signup: {
    credentials: {
      email: {
        changed: false,
        touched: false,
        valid: false,
        value: '',
        focus: false,
        valueChanged: false
      },
      password: {
        changed: false,
        touched: false,
        valid: false,
        value: '',
        focus: false,
        valueChanged: false
      },
      error: ''
    },
    isSso: false,
    loading: false,
    showUserInfo: false,
    userInfo: {
      student: {
        middleschool: {
          msGradYear: 0,
          grades: [{
            text: '6th'
          }, {
            text: '7th'
          }, {
            text: '8th'
          }]
        },
        highschool: {
          hsGradYear: 0,
          years: getCollegeYears()
        },
        college: {
          campusId: '',
          name: '',
          yearInCollege: 0,
          years: [{
            text: '1st'
          }, {
            text: '2nd'
          }, {
            text: '3rd'
          }, {
            text: '4th'
          }, {
            text: '5th+'
          }],
          isCollegeSelected: false
        }
      }
    },
    gdpr: {
      termsOfUse: false,
      promos: false
    }
  },
  resetPassword: {
    credentials: {
      email: {
        changed: false,
        touched: false,
        valid: false,
        value: '',
        focus: false,
        valueChanged: false
      },
      error: ''
    },
    loading: false,
    recaptcha: null,
    successScreen: false
  },
  mfa: {
    mfaPayload: {
      mfa_token: '',
      uuid: '',
      email: ''
    },
    screen: '',
    id: '',
    showMfa: false,
    authProvider: '',
    codeValidationError: '',
    isSso: false
  },
  isGdpr: false
};